import styled from 'styled-components';
import { Alert, Button } from 'antd';

export const TableWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  border-radius: 6px;
  background: #fff;
  border: 1px solid #e8e8e8;

  .BaseTable__header {
    background: #fafafa;
    border-bottom: 1px solid #e8e8e8;
  }

  .BaseTable__header-cell {
    padding: 0;
    font-size: 11px;
    color: #8c8c8c;
    text-transform: uppercase;
    letter-spacing: 0.7px;
    font-weight: 600;
  }

  .BaseTable__row {
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background: #fafafa;
    }
  }

  .BaseTable {
    overflow: hidden !important;
  }

  .BaseTable__header,
  .BaseTable__body {
    overflow: hidden !important;
  }
`;

export const Row = styled.a`
  display: flex;
  width: 100%;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;
  color: inherit;
  height: 100%;

  &:hover {
    color: inherit;
  }

  &:visited {
    color: inherit;
  }
`;

export const FullCell = styled.div<{ $width?: number }>`
  padding: 0 16px 0 18px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  flex: ${({ $width }) => ($width ? `0 0 ${$width}px` : '1 1 0')};
  font-weight: 600;
  font-size: 14px;
  color: #1a1a1a;
  line-height: 1.4;
  display: flex;
  align-items: center;
`;

export const Cell = styled.div<{ $width?: number }>`
  padding: 0 16px;
  overflow: visible;
  flex: ${({ $width }) => ($width ? `0 0 ${$width}px` : '1 1 0')};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
`;

export const CellNumber = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
  line-height: 1.3;
`;

export const CellPrimary = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: #1a1a1a;
  white-space: nowrap;
`;

export const CellSecondary = styled.span`
  font-size: 13px;
  color: #8c8c8c;
  font-weight: 400;
  white-space: nowrap;
`;

export const HeaderCell = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  padding-left: 16px;
`;

export const HeaderTitle = styled.span`
  font-weight: 600;
  font-size: 11px;
  color: #8c8c8c;
  text-transform: uppercase;
  letter-spacing: 0.7px;
`;

export const TrendValue = styled.span<{ $positive?: boolean; $neutral?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-size: 13px;
  font-weight: 600;
  padding: 1px 5px;
  border-radius: 3px;
  white-space: nowrap;
  color: #0f93f5;
  background: #e6f5ff;

  .anticon {
    font-size: 10px;
  }
`;

export const DeleteButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const DeleteButton = styled(Button)`
  &.ant-btn-dangerous {
    font-size: 15px;
    border-radius: 4px;

    .anticon {
      font-size: 15px;
    }
  }
`;

export const DragHandle = styled.div`
  position: absolute;
  left: 6px;
  top: 50%;
  transform: translateY(-50%);
  color: #000;
  cursor: grab;
  z-index: 10;
  padding: 6px;
  font-size: 18px;
  display: flex;
  align-items: center;

  &:hover {
    color: #8c8c8c;
  }

  &:active {
    cursor: grabbing;
  }
`;

export const DraggableRow = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  background: #fff;
`;

export const RowWrapper = styled.div`
  flex: 1;
  padding-left: 32px;
  height: 100%;
  display: flex;
  align-items: stretch;
`;

export const DeletedEventCell = styled(FullCell)`
  align-items: center;
  padding: 0 16px;
  border-left: 3px solid #ff4d4f;
`;

export const DeletedEventAlert = styled(Alert)`
  display: inline-flex;
  width: auto;
  border-radius: 4px;
  font-size: 13px;
`;
